module.exports = {
  AdminStaticTableWithScroll: require('./StaticTableWithScroll'),
  AdminStaticTable: require('./StaticTable'),
}
